import React, { useMemo, } from 'react';
import { entries, orderBy, } from 'lodash';
import { format as formatDate } from 'date-fns';

import { operationTypes } from '../shared/config';
import useCollectionSubscription from './hooks/useCollectionSubscription';
import useCompany from './hooks/useCompany';
import useQueryParams from './hooks/useQueryParams';
import ModalButton from './ModalButton';

export default function OperationHistoryButton (props) {
  const { type, types: typesProp, payloadFilters, size = 'sm', color = 'link', className = 'p-0 text-muted', } = props;

  return (
    <ModalButton {...{ size, color, className, }} title="履歴" content={_ => <OperationHistory type={type} types={typesProp} payloadFilters={payloadFilters} />}>
      <span className="fas fa-history" />
    </ModalButton>
  );
};

function OperationHistory (props) {
  const { type, types: typesProp, payloadFilters, } = props;
  const types = typesProp || [type];
  const { yearMonth, } = useQueryParams();
  const company = useCompany();
  const collectionRef = useMemo(_ => {
    let ref = company?.ref.collection('logs').where('operationType', types.length === 1 ? '==' : 'in', types.length === 1 ? types[0] : types).where('payload.yearMonth', '==', yearMonth);
    entries(payloadFilters || {}).map(([k, v]) => {
      ref = ref.where(`payload.${k}`, '==', v);
    });
    return ref;
  }, [company != null, JSON.stringify(types), yearMonth, JSON.stringify(payloadFilters)]);
  const _logs = useCollectionSubscription(collectionRef, [collectionRef]);
  const logs = useMemo(_ => orderBy(_logs, _ => _.createdAt?.toDate(), 'desc'), [_logs]);
  return (
    <div className="d-flex flex-column gap-3">
      {
        logs.map((log) => {
          const { id, operationType, createdAt, createdBy, payload, } = log;
          return (
            <div key={id}>
              <div className="d-flex gap-1 text-muted small">
                <div>
                  {formatDate(createdAt.toDate(), 'yyyy/MM/dd HH:mm:ss')}
                </div>
                <div>
                  {createdBy.displayName}
                </div>
              </div>
              <div>
                {operationTypes[operationType]?.label} ({payload.yearMonth.slice(0, 4)}/{payload.yearMonth.slice(4)})
              </div>
            </div>
          );
        })
      }
    </div>
  );
}
